import { ReactNode } from 'react';
import { Typography, makeStyles } from '@material-ui/core';
import { Link } from '@backstage/core-components';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  icon: {
    display: 'inline-flex',
    color: theme.palette.text.secondary,
  },
  link: {
    marginLeft: theme.spacing(1),
    fontSize: theme.typography.body2.fontSize,
    fontWeight: 'normal',
  },
}));

/** Заголовок таблицы на главной: иконка, название, ссылка на полную страницу. */
export const CardTitle = ({
  icon,
  text,
  to,
  linkText,
}: {
  icon: ReactNode;
  text: string;
  to: string;
  linkText: string;
}) => {
  const classes = useStyles();
  return (
    <span className={classes.root}>
      <span className={classes.icon}>{icon}</span>
      <Typography variant="h5" component="span">
        {text}
      </Typography>
      <Link to={to} className={classes.link}>
        {linkText} →
      </Link>
    </span>
  );
};
